import { render } from "./ArrowIcon.vue?vue&type=template&id=07c1579d&scoped=true&ts=true"
import script from "./ArrowIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowIcon.vue?vue&type=script&lang=ts"

import "./ArrowIcon.vue?vue&type=style&index=0&id=07c1579d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c1579d"]])

export default __exports__